import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";

class YoutubeView extends Component {
  render() {
    return <Layout {...this.props} type="YoutubeView" />;
  }
}

YoutubeView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func
};

export default YoutubeView;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/YoutubeView.js